<template>
    <div>
    </div>
</template>

<script>
import ps from '../../api/LodopFuncs';
export default {
    props:{
        printCol:{
            type:String,
            default:'',
        }
    },
    data(){
        return{
            detailModel:false,
            ptitle:'订货',
            printDesc:"订货单",
            beforeUrl:"",
            afterUrl:"",
            printModel:{
                footerSign:'',
            },
        }
    },
    created(){
        this.$api.systemgetPrintInfo().then(res=>{
            if(res.data.code==1&&res.data.data.list.length>0){
                let obj = res.data.data.list[0];
                if(obj.detail){
                    this.printModel.footerSign = obj.detail.footerSign?obj.detail.footerSign:'';
                }
            }
        })
    },
    methods:{
        initData(key){
            if(key==1){
                this.ptitle = "发货"
                this.printDesc = "销售单";
                this.beforeUrl = "/emp/print/printOrderSend?id=";
                this.afterUrl = "&template=1&columns=index,pnumber,prod,amount,parts,unit,cancelUnit,money,remark&showDetail=0";
            }else if(key==2){
                this.ptitle = ""
                this.printDesc = "客户未发货统计";
                this.beforeUrl = "/emp/print/printOrderByCust?cmp=";
                this.afterUrl = "&dateRange=&start=&end=&pcategory=&cucategory=&states=&color=&size=&sendstate=1&confirmed=1&cids=&pids=&notsend=0&notsendStatus=false&remark=&pname=&pnumber=&page=1&limit=10&column=&order=&template=1&columns=index,cust,prod,price,amount,money,sendedAmount,notSendAmount,remark&showDetail=0";
            }else if(key==3){
                this.ptitle = ""
                this.printDesc = "员工未发货统计";
                this.beforeUrl = "/emp/print/printOrderByEmp?cmp=";
                this.afterUrl = "&emps=&dateRange=&start=&end=&color=&size=&sendstate=1&confirmed=1&pcategory=&cucategory=&states=&notsend=0&notsendStatus=false&cids=&pids=&remark=&pname=&pnumber=&page=1&limit=10&column=&order=&template=1&columns=index,emp,prod,price,cust,amount,money,sendedAmount,notSendAmount,remark&showDetail=0";
            }else if(key==4){
                this.ptitle = ""
                this.printDesc = "商品未发货统计";
                this.beforeUrl = "/emp/print/printOrderByProd?cmp=";
                this.afterUrl = "&dateRange=&start=&end=&pcategory=&cucategory=&color=&size=&spname=&sendstate=1&confirmed=1&states=&cids=&pids=&remark=&pnumber=&notsendStatus=false&page=1&limit=10&column=&order=&template=1&columns=index,prod,price,cust,amount,sendedAmount,notSendAmount,remark&showDetail=0";
            }else if(key==5){
                this.ptitle = ""
                this.printDesc = "应收报表";
                this.beforeUrl = "/emp/print/printNeedPayment?cmp=";
                this.afterUrl = "&page=1&limit=10&template=1&columns=cnumber,category,beginbill,sumAmount,sumUnit,total,pay,free,needPay&showDetail=0";
            }else if(key==6){
                let cc = this.$global.cmpId.cmp;
                this.ptitle = ""
                this.printDesc = "客户对账单";
                this.beforeUrl = "/emp/print/printCustomerPayment?cmp="+cc+"&cid=";
                this.afterUrl = "&eid=&daterange=&category=&categoryName=&column=&order=&page=1&limit=10&template=1&showDetail=0";
            }else if(key==7){
                this.ptitle = ""
                this.printDesc = "收款记录";
                this.beforeUrl = "/emp/print/printPayment?cmp=";
                this.afterUrl = "&cid=&cname=&cnumber=&from=&column=&order=&start=&end=&category=&categoryName=&template=1&showDetail=0";
            }else if(key==8){
                this.ptitle = ""
                this.printDesc = "收支记录";
                this.beforeUrl = "/emp/print/printOtherPayment?cmp=";
                this.afterUrl = "&cid=&eid=&daterange=&start=&end=&category=&categoryName=&column=&order=&page=1&limit=10&template=1&showDetail=0";
            }else if(key==9){
                var token = localStorage.getItem("token");
                this.ptitle = ""
                this.printDesc = "库存明细";
                this.beforeUrl = "/emp/print/printStock?cmp=";
                this.afterUrl = "&token="+token+"&page=1&limit=10&pid=&sended=false&pname=&pnumber=&cid=&cname=&cnumber=&wid=&color=&size=&label=&column=&order=&template=1&columns=pnumber,sp,unit,inStock,od,sended,notSend,stock&showDetail=0";
            }else if(key==10){
                var token = localStorage.getItem("token");
                this.ptitle = ""
                this.printDesc = "出入库汇总";
                this.beforeUrl = "/emp/print/printStockReport?cmp=";
                this.afterUrl = "&token="+token+"&page=1&limit=10&pid=&pname=&pnumber=&time=&start=&end=&wid=&color=&size=&column=&order=&template=1&columns=index,prod,spec,price,packing,wname,inAmount,inPrice,outAmount,outPrice,editAmount,editPrice&showDetail=0";
            }else if(key==11){
                var token = localStorage.getItem("token");
                this.ptitle = ""
                this.printDesc = "入库明细";
                this.beforeUrl = "/emp/print/printStockDetail?cmp=";
                this.afterUrl = "&token="+token+"&page=1&limit=10&pid=&pname=&pnumber=&cname=&cnumber=&oremark=&note=&time=&type=1&start=&end=&wid=&cid=&color=&size=&column=&order=&template=1&columns=index,date,cname,prod,packing,price,inAmount,inPrice&showDetail=0";
            }else if(key==12){
                var token = localStorage.getItem("token");
                this.ptitle = ""
                this.printDesc = "出库明细";
                this.beforeUrl = "/emp/print/printStockDetail?cmp=";
                this.afterUrl = "&token="+token+"&page=1&limit=10&pid=&pname=&pnumber=&cname=&cnumber=&oremark=&note=&time=&type=2&start=&end=&wid=&cid=&color=&size=&column=&order=&template=1&columns=index,date,cname,prod,packing,price,outAmount,outPrice&showDetail=0";
            }else if(key==13){
                var token = localStorage.getItem("token");
                this.ptitle = ""
                this.printDesc = "更改明细";
                this.beforeUrl = "/emp/print/printStockDetail?cmp=";
                this.afterUrl = "&token="+token+"&page=1&limit=10&pid=&pname=&pnumber=&cname=&cnumber=&oremark=&note=&time=&type=3&start=&end=&wid=&cid=&color=&size=&column=&order=&template=1&columns=index,date,cname,prod,packing,price,editAmount,editPrice&showDetail=0";
            }else if(key==14||key==15){
                this.ptitle = ""
                this.printDesc = "采购单";
                this.beforeUrl = "/emp/print/printMaterialOrder?id=";
                this.afterUrl = "&template=1&columns=index,mnumber,material,amount,price,money,remark&showDetail=0";
            }else if(key==16||key==17){
                this.ptitle = ""
                this.printDesc = "";
                this.beforeUrl = "/emp/print/printRecordHead?id=";
                this.afterUrl = "&template=1&columns=index,mnumber,material,amount,price,money,remark&showDetail=0";
            }else{
                this.ptitle = "下单"
                this.printDesc = "订货单";
                this.beforeUrl = "/emp/print/printOrder?id=";
                let str = this.printCol?this.printCol:'index,pnumber,prod,punit,amount,price,unit,money,remark';
                this.afterUrl = '&columns=' + encodeURIComponent(str);
            }
        },
        extraOpen(key,arr){
            if(!arr){
                return;
            }
            this.detailModel = true;
            this.initData(key);
            this.printobj(arr);
        },
        extraCheckOpen(key,arr,callback){
            if(!arr){
                return;
            }
            this.initData(key);
            this.detailModel = false;
            let ua = navigator.userAgent;
            if(ua.indexOf("Windows")>-1){
                this.$confirm('是否打印'+this.printDesc+'?', this.ptitle+'成功', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'success'
                }).then(() => {
                    this.printobj(arr);
                    callback(); 
                }).catch(() => {
                    callback();  
                });
            }else{
                callback();
            }
        },
        printobj(arr){
            this.$nextTick(() => {
                let LODOP = ps.getLodop(); //调用getLodop获取LODOP对象
                if(LODOP){
                    LODOP.PRINT_INIT(this.printDesc);
                    LODOP.SET_PRINT_STYLE("FontSize", 15);
                    LODOP.SET_PRINT_PAGESIZE(0, 2100, 2970);
                    LODOP.SET_PRINT_STYLE("Bold", 1);
                    if(arr!=null&&arr.length>0){
                        arr.forEach(e => {
                            LODOP.NewPage();
                            var path = this.$api.baseURL + this.beforeUrl + e + this.afterUrl;
                            LODOP.ADD_PRINT_TBURL('5%','5%', "90%","90%", path);
                            LODOP.SET_PRINT_STYLEA(0, 'TableHeightScope', 1)
                            LODOP.ADD_PRINT_TEXT(20, 0, '100%', '5mm', this.printModel.footerSign);
                            LODOP.SET_PRINT_STYLEA(0, 'LinkedItem', -1);
                            LODOP.SET_PRINT_STYLEA(0, 'Alignment', 1);
                        });
                    }
                    LODOP.PREVIEW();
                }else{
                    this.$confirm('是否下载插件?', '没有插件或插件版本过旧', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'info'
                    }).then(() => {
                        this.download();
                    }).catch(() => {   
                    });
                }
            })
        },
        download(){
            try {
                var elemIF = document.createElement("iframe");
                elemIF.src = "http://xy.shuntun.com/shoes/CLodop_Setup_for_Win32NT.exe";
                elemIF.style.display = "none";
                document.body.appendChild(elemIF);
            } catch (e) {
                alert("下载异常!");
            }
        },
    }
}
</script>